import { render } from "./MiBtnDropdown.vue?vue&type=template&id=a9618c38&scoped=true"
import script from "./MiBtnDropdown.vue?vue&type=script&lang=js"
export * from "./MiBtnDropdown.vue?vue&type=script&lang=js"

import "./MiBtnDropdown.vue?vue&type=style&index=0&id=a9618c38&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9618c38"]])

export default __exports__
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnDropdown,QBtn,QIcon});
